import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    component: () => import('@/layout/Layout.vue'),
    redirect: '/home',
    children: [
      { path: 'home', component: () => import('@/views/Home.vue'), meta: { title: '首页' } },
      { path: 'about', component: () => import('@/views/about/AboutEdit.vue'), meta: { title: '商会简介' } },
      { path: 'banner', component: () => import('@/views/banner/BannerList.vue'), meta: { title: '轮播图管理' } },
      { path: 'news', component: () => import('@/views/news/NewsList.vue'), meta: { title: '新闻资讯' } },
      { path: 'member', component: () => import('@/views/member/MemberList.vue'), meta: { title: '会员管理' } },
      { path: 'supply-demand', component: () => import('@/views/supply/SupplyDemandList.vue'), meta: { title: '供求信息' } },
      { path: 'activity', component: () => import('@/views/activity/ActivityList.vue'), meta: { title: '活动管理' } },
      { path: 'change-password', component: () => import('@/views/ChangePassword.vue'), meta: { title: '修改密码' } }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.path === '/login') {
    next()
  } else if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router
